import { render, staticRenderFns } from "./AccessControl.vue?vue&type=template&id=8504aef2&scoped=true"
import script from "./AccessControl.vue?vue&type=script&lang=js"
export * from "./AccessControl.vue?vue&type=script&lang=js"
import style0 from "./AccessControl.vue?vue&type=style&index=0&id=8504aef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8504aef2",
  null
  
)

export default component.exports